import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IExportLog, ILogLine } from '../model/log.model';

@Injectable({
  providedIn: 'root'
})
export class ExportLogService {

  constructor(
    protected firestore: AngularFirestore,
  ) { }

  public get(bankAccountId: number, id: string): Observable<IExportLog> {
    return this.firestore.collection<IExportLog>(`bank-accounts/${bankAccountId}/exportLogs`).doc(id).get().pipe(
      map(snapshot => snapshot.data() as IExportLog),
    );
  }

  public getAll(bankAccountId: number): Observable<IExportLog[]> {
    const collection = `bank-accounts/${bankAccountId}/exportLogs`;
    return this.firestore.collection<IExportLog>(collection, ref => ref.orderBy('datetime', 'desc').limit(5)).valueChanges({ idField: 'id' });
  }

  public getLogLines(bankAccountId: number, exportLogId: string): Observable<ILogLine[]> {
    const collection = `bank-accounts/${bankAccountId}/exportLogs/${exportLogId}/lines`;
    return this.firestore.collection<ILogLine>(collection, ref => ref.orderBy('timestamp')).valueChanges();
  }

}
